<script setup lang="ts">
/**
 * UI-kit component
 * Category: Tooltip
 * Name: AppHoverCard
 * FIGMA:
 */
import type { AppHoverCardProps } from '../types/interfaces'

import { useAppHoverCard } from '../composables/app-hover-card.hook'

defineOptions({
  name: 'AppHoverCard',
})

const props = withDefaults(defineProps<AppHoverCardProps>(), {
  placement: 'bottom',
  offset: 8,
  delay: 100,
  teleportTo: 'body',
})

const {
  cardId,
  triggerRef,
  cardRef,
  show,
  cardState,
  floatingStyles,
  resolvedPlacement,
  resolvedSide,
  teleportTarget,
  showCard,
  hideCard,
  cancelHide,
  toggleCard,
  setAnimationEnd,
  setKeydown,
  setCardEnter,
  setCardLeave,
  setTriggerFocusout,
  setCardFocusout,
} = useAppHoverCard({ props })
</script>

<template>
  <span
    ref="triggerRef"
    class="app-hover-card-trigger"
    :aria-describedby="show ? cardId : undefined"
    @mouseenter="showCard"
    @mouseleave="hideCard"
    @touchstart.passive="toggleCard"
    @focusin="showCard"
    @focusout="setTriggerFocusout"
    @keydown="setKeydown"
  >
    <slot />
  </span>

  <Teleport
    :to="teleportTarget"
    :disabled="teleportTo === false"
  >
    <div
      v-if="show"
      ref="cardRef"
      class="app-hover-card"
      :style="floatingStyles"
      @mouseenter="setCardEnter"
      @mouseleave="setCardLeave"
      @focusin="cancelHide"
      @focusout="setCardFocusout"
    >
      <div
        :id="cardId"
        role="tooltip"
        class="app-hover-card__body"
        :data-state="cardState"
        :data-placement="resolvedPlacement"
        :data-side="resolvedSide"
        @animationend="setAnimationEnd"
      >
        <slot name="content" />
      </div>
    </div>
  </Teleport>
</template>

<style lang="scss" scoped src="../styles/_app-hover-card.scss" />
